const c = ["#00939c", "#8cced1", "#bae1e2", "#f8c0aa", "#c22e00"], e = [
  "#00939c",
  "#8cced1",
  "#bae1e2",
  "#f8c0aa",
  "#dd7755",
  "#c22e00"
], a = [
  "#00939c",
  "#5dbabf",
  "#8cced1",
  "#bae1e2",
  "#f8c0aa",
  "#dd7755",
  "#c22e00"
], _ = [
  "#00939c",
  "#5dbabf",
  "#8cced1",
  "#bae1e2",
  "#f8c0aa",
  "#dd7755",
  "#d0532b",
  "#c22e00"
], d = [
  "#00939c",
  "#2fa7ae",
  "#5dbabf",
  "#8cced1",
  "#bae1e2",
  "#f8c0aa",
  "#dd7755",
  "#d0532b",
  "#c22e00"
], b = [
  "#00939c",
  "#2fa7ae",
  "#5dbabf",
  "#8cced1",
  "#bae1e2",
  "#f8c0aa",
  "#eb9c80",
  "#dd7755",
  "#d0532b",
  "#c22e00"
];
export {
  b as HEAT_MAP_BLUE_RED_10,
  c as HEAT_MAP_BLUE_RED_5,
  e as HEAT_MAP_BLUE_RED_6,
  a as HEAT_MAP_BLUE_RED_7,
  _ as HEAT_MAP_BLUE_RED_8,
  d as HEAT_MAP_BLUE_RED_9
};
//# sourceMappingURL=index.es5677.js.map
